export default [
  { title: 'Quem Somos', to: '#!' },
  { title: 'Fale Conosco', to: '#!' },
  { title: 'Termos e Condições', to: '#!' },
];